import { createIcon } from '@chakra-ui/react';

export const Lightbulb = createIcon({
  displayName: 'Lightbulb',
  viewBox: '0 0 24 24',
  path: (
    <g id="Icon" transform="translate(-57 -709)">
      <rect
        id="Icon_Space"
        data-name="Icon Space"
        transform="translate(57 709)"
        fill="none"
      />
      <g
        id="Light_Bulb_-_L"
        data-name="Light Bulb - L"
        transform="translate(62.193 709)"
      >
        <path
          id="Light_Bulb_-_L-2"
          data-name="Light Bulb - L"
          d="M25.88,12.163A8.929,8.929,0,0,0,27.66,6.9,6.532,6.532,0,0,0,21.015.5h-.151A6.53,6.53,0,0,0,14.22,6.9,8.981,8.981,0,0,0,16,12.163l.151.246a9.8,9.8,0,0,1,1.134,3.061h-.756a.559.559,0,0,0-.559.559v2.336a.559.559,0,0,0,.559.559h8.224v1.243H16.537a.567.567,0,0,0,0,1.134h.7a3.4,3.4,0,0,0,3.371,3.024h.627A3.4,3.4,0,0,0,24.61,21.3h.7a.559.559,0,0,0,.559-.582V18.366a.559.559,0,0,0-.559-.559H17.1V16.589h8.186a.567.567,0,1,0,0-1.134H24.6a9.641,9.641,0,0,1,1.134-3.061ZM21.238,23.192h-.627a2.268,2.268,0,0,1-2.237-1.89h5.1a2.268,2.268,0,0,1-2.237,1.89Zm3.534-11.361a10.983,10.983,0,0,0-1.311,3.64H18.419a10.983,10.983,0,0,0-1.311-3.64l-.147-.249A7.894,7.894,0,0,1,15.339,6.9a5.424,5.424,0,0,1,5.526-5.291h.151A5.416,5.416,0,0,1,26.541,6.9a7.929,7.929,0,0,1-1.621,4.683Zm-2.842-1.6H20.592l.756-2.842a.563.563,0,1,0-1.092-.276l-.93,3.545a.563.563,0,0,0,.54.7h1.345l-.65,2.555a.563.563,0,0,0,.408.68.571.571,0,0,0,.68-.408l.809-3.243a.559.559,0,0,0-.544-.7Z"
          transform="translate(-14.22 -0.5)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
